/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import {
	default as JSG,
	ImagePool,
	ItemAttributes,
	AttributeUtils,
	SetAttributeAtPathCommand,
	CellRange,
	SheetCommandFactory
} from '@cedalo/jsg-core';
import NodeView from './NodeView';

export default class SheetJsonView extends NodeView {
	drawFill(graphics, format, rect) {
		super.drawFill(graphics, format, rect);

		const item = this.getItem();
		const attr = item.getAttributeAtPath('json');
		if (!attr) {
			return;
		}

		const json = attr.getExpression().getTermValue();
		if (!json || !(json instanceof Object)) {
			return;
		}


		Object.values(json).forEach(shape => {
			if (!shape) {
				return;
			}
			const params = String(shape).split(';');
			graphics.setLineColor('#000000');
			graphics.setFillColor('#FFFFFF');
			graphics.setLineWidth(-1);
			switch (String(params[0])) {
			case 'Line': {
				if (params.length < 5) {
					return;
				}
				const x1 = JSG.Numbers.canBeNumber(params[1]) ? Number(params[1]) : 0;
				const y1 = JSG.Numbers.canBeNumber(params[2]) ? Number(params[2]) : 0;
				const x2 = JSG.Numbers.canBeNumber(params[3]) ? Number(params[3]) : 0;
				const y2 = JSG.Numbers.canBeNumber(params[4]) ? Number(params[4]) : 0;
				if (params.length > 5) {
					graphics.setLineColor(params[5]);
				}
				graphics.beginPath();
				graphics.moveTo(x1, y1);
				graphics.lineTo(x2, y2);
				graphics.stroke();
				break;
			}
			case 'Rect': {
				if (params.length < 5) {
					return;
				}
				const x = JSG.Numbers.canBeNumber(params[1]) ? Number(params[1]) : 0;
				const y = JSG.Numbers.canBeNumber(params[2]) ? Number(params[2]) : 0;
				const width = JSG.Numbers.canBeNumber(params[3]) ? Number(params[3]) : 0;
				const height = JSG.Numbers.canBeNumber(params[4]) ? Number(params[4]) : 0;
				if (params.length > 5) {
					graphics.setLineColor(params[5]);
				}
				if (params.length > 6) {
					graphics.setFillColor(params[6]);
				}
				graphics.beginPath();
				graphics.rect(x, y, width, height);
				graphics.fill();
				graphics.stroke();
				break;
			}
			case 'Text': {
				// Type;X;Y;Text;FontName;FontSize;FontColor;HAlign;VAlign
				if (params.length < 3) {
					return;
				}

				const x = JSG.Numbers.canBeNumber(params[1]) ? Number(params[1]) : 0;
				const y = JSG.Numbers.canBeNumber(params[2]) ? Number(params[2]) : 0;

				graphics.setFontName(params.length > 4 && params[4].length ? params[4] : 'Verdana');
				graphics.setFontSize(params.length > 5  && JSG.Numbers.canBeNumber(params[5]) ? Number(params[5]) : 9);
				graphics.setFillColor(params.length > 6 && params[6].length ? params[6] : '#000000');
				graphics.setTextAlignment(params.length > 7  && JSG.Numbers.canBeNumber(params[7]) ? Number(params[7]) : JSG.TextFormatAttributes.TextAlignment.CENTER);
				graphics.setTextBaseline(params.length > 8 ? params[8] : 'middle');

				graphics.setFont();
				graphics.fillText(String(params[3]), x, y);
				break;
			}
			default:
				break;
			}
		});
	}

}
